import React, { useEffect, useRef, useState } from 'react';
import { Search, X } from 'lucide-react';
import api from '../api';

// Typeahead de clientes: busca por casillero/nombre/correo (GET /clientes/?search=)
// en vez de traer los 300+ de una y armar un <select> gigante.
export default function SeleccionarClienteInput({ seleccionado, onSelect, label = 'Cliente' }) {
  const [query, setQuery] = useState('');
  const [resultados, setResultados] = useState([]);
  const [abierto, setAbierto] = useState(false);
  const [buscando, setBuscando] = useState(false);
  const debounceRef = useRef(null);

  useEffect(() => {
    if (!query.trim()) {
      setResultados([]);
      return;
    }
    setBuscando(true);
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      api.get('/clientes/', { params: { search: query, page_size: 10 } })
        .then((res) => setResultados(res.data.results || res.data))
        .catch(() => setResultados([]))
        .finally(() => setBuscando(false));
    }, 300);
    return () => clearTimeout(debounceRef.current);
  }, [query]);

  if (seleccionado) {
    return (
      <div>
        <label>{label}</label>
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          border: '1px solid var(--color-border)', borderRadius: 'var(--radius-md)',
          padding: '8px 12px', background: 'var(--color-surface)',
        }}>
          <span>
            <strong className="mono">{seleccionado.codigo_casillero}</strong> — {seleccionado.nombre}
          </span>
          <button type="button" className="btn-ghost btn-sm" onClick={() => { onSelect(null); setQuery(''); }}>
            <X size={14} />
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ position: 'relative' }}>
      <label>{label}</label>
      <div style={{ position: 'relative' }}>
        <Search size={16} style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: 'var(--color-text-secondary)' }} />
        <input
          value={query}
          onChange={(e) => { setQuery(e.target.value); setAbierto(true); }}
          onFocus={() => setAbierto(true)}
          placeholder="Buscar por casillero, nombre o correo..."
          style={{ paddingLeft: '34px' }}
        />
      </div>
      {abierto && query.trim() && (
        <div className="card card--compact" style={{
          position: 'absolute', zIndex: 20, width: '100%', marginTop: '4px',
          maxHeight: '220px', overflowY: 'auto', padding: 'var(--spacing-2)',
        }}>
          {buscando ? (
            <p className="text-secondary text-sm" style={{ margin: 0 }}>Buscando...</p>
          ) : resultados.length === 0 ? (
            <p className="text-secondary text-sm" style={{ margin: 0 }}>Sin resultados.</p>
          ) : resultados.map((c) => (
            <div
              key={c.id}
              onClick={() => { onSelect(c); setAbierto(false); }}
              style={{ padding: '6px 8px', cursor: 'pointer', borderRadius: 'var(--radius-sm)' }}
              onMouseEnter={(e) => { e.currentTarget.style.background = 'var(--color-surface)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
            >
              <strong className="mono text-sm">{c.codigo_casillero}</strong>
              <span className="text-sm"> — {c.nombre}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
